import React from 'react';
import { RefreshCw } from 'lucide-react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="text-center py-4">
      <RefreshCw className="w-6 h-6 animate-spin mx-auto text-orange-500" />
      <p className="text-sm text-gray-600 mt-2">{message}</p>
    </div>
  );
};

export default LoadingSpinner;